module.exports = __webpack_public_path__ + "static/media/close-mob.e2c28488.svg";